import { SalesOrderDeliveryReport } from './sales-order-delivery-report';
import { SalesOrderExtraReport } from './sales-order-extra-report';
import { SalesOrderProformaReportLine } from './sales-order-proforma-report-line';
import { SellingCompanyReport } from '../../../../tms-shared';

export interface SalesOrderProformaReport {
  id: string;
  orderNo: number;
  customerKey: string;
  customerName: string;
  customerOrderNo: string;
  customerOrderRef: string;
  customerConfirmationEmailAddress: string;
  currency: string;
  currencySymbol: string;
  dateOrdered?: Date;
  enteredBy: string;
  customerAddress: string;
  deliveryAddress: string;
  invoiceAddress: string;
  paymentTerms: string;
  deliveryTerms: string;
  modeOfTransport: string;
  shipper: string;
  goodsValue: number;
  processValue: number;
  totalDeliveryValue: number;
  totalExtraValue: number;
  nettValue: number;
  taxRate: number;
  taxValue: number;
  overallValue: number;
  notes: string;
  bankName: string;
  bankAccountName: string;
  bankIBAN: string;
  bankSwift: string;
  bankAccount: string;
  bankSortCode: string;
  bankNarrative: string;
  documentNotes: string;
  deliveryInstructions: string;
  deliveryTermNotes: string;
  shippingNotes: string;
  agentName: string;
  deliveryAddressee: string;
  invoiceAddressee: string;
  printDeliveryAddress: boolean;

  sellingCompany: SellingCompanyReport;
  salesOrderLines: SalesOrderProformaReportLine[];
  salesOrderDeliveryItems: SalesOrderDeliveryReport[];
  salesOrderExtraItems: SalesOrderExtraReport[];
  orderedBy: string;
}
